import { AccountType } from '@/data/usecases/account/account-type'
import { Account } from '@/domain/usecases'
import { queryClient } from '@/infra/http'

/**
 * Loads dependent licenses for company manager
 * Returns only licenses for dependent account type
 */
export async function loadCompanyManagerDependentLicenses(account: Account.Model) {
  const module = await import(
    '@remote/account/company-manager/remote-company-manager-plan-license-factory'
  )
  const makeRemotePlanLicense = module.makeRemoteCompanyPlanLicense
  const remote = makeRemotePlanLicense(account.company.uniqueId, queryClient)
  const licenses = await remote.loader()

  return {
    licenses: licenses.filter(license => license.accountType === AccountType.Enum.DEPENDENT)
  }
}
